import QrCode from './qrCode';

export default QrCode;
